import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CompanyStats from "../CompanyStats/CompanyStats";

const injectStyles = `
  @import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css');

  .rev-section {
    padding: 30px 10px;
    font-family: 'hauora-medium', sans-serif !important;
  }

 
  .rev-header h2 {
  font-family: 'hauora-medium' !important;
  color: #212529;
  width: 100% !important;
  text-align: center;
   }

  .rev-header p {
    font-family: 'hauora-medium', sans-serif !important;
   
    color: #212529;
    max-width: 900px;
    margin: 0 auto;
    
  }

  .rev-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .rev-card {
    background: #ffffff;
    border-radius: 8px;
    padding: 30px 25px;
    box-shadow: 0 10px 30px rgba(178, 35, 53, 0.1);
    border-bottom: 4px solid #b22335;
    display: flex;
    align-items: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    text-decoration: none !important; /* জোরপূর্বক ডেকোরেশন সরানো হয়েছে */
    color: inherit;
  }

  .rev-card:visited {
    color: inherit;
    text-decoration: none;
  }

  .rev-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 25px rgba(178, 35, 53, 0.3);
    text-decoration: none;
    color: inherit;
  }

  .rev-icon-box {
    width: 60px;
    height: 60px;
    border-radius: 6px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(178, 35, 53, 0.2);
    border-bottom: 4px solid #b22335;
  }

  .rev-content h4 {
    font-weight: 700;
    color: #b22335;
    margin: 0;
    font-size: 1.1rem;
    font-family: 'hauora-medium', sans-serif !important;
  }

  .rev-content p {
    color: #7a7a7a;
    margin: 2px 0 8px 0;
    font-size: 14px;
    font-family: 'hauora-medium', sans-serif !important;
  }

  .rev-stars i {
    color: #b22335;
    font-size: 14px;
    margin-right: 2px;
  }

  @media (max-width: 1024px) {
    .rev-wrapper { grid-template-columns: 1fr 1fr; }
  }

  @media (max-width: 576px) {
    .rev-wrapper { grid-template-columns: 1fr; }
     .rev-section {
    padding: 10px 10px;
    
  }
        .container {
         padding-left: 2px; 
         padding-right: 2px; 
    }
  }
`;

export default function CallbackSection() {
  useEffect(() => {
    const tag = document.createElement("style");
    tag.innerHTML = injectStyles;
    document.head.appendChild(tag);
    return () => {
      if (document.head.contains(tag)) document.head.removeChild(tag);
    };
  }, []);

  const reviewData = [
    {
      platform: "Facebook Reviews",
      count: "166 reviews",
      icon: "bi-facebook",
      link: "https://www.facebook.com/UltimateSRoofing/reviews",
      iconType: "bootstrap"
    },
    {
      platform: "Google Reviews",
      count: "232 reviews",
      icon: "bi-google",
      link: "https://share.google/C86bNWDWTanx3TsEH",
      iconType: "bootstrap"
    },
    {
      platform: "Trustpilot Reviews",
      count: "8 reviews",
      icon: "bi-star-fill",
      link: "https://www.trustpilot.com/review/ultimatesroofing.com",
      iconType: "trustpilot"
    },
  ];

  const renderIcon = (rev) => {
    if (rev.iconType === "trustpilot") {
      return (
        <svg viewBox="0 0 24 24" width="30" height="30">
          <path
            d="M12 2L14.09 8.26L20.18 8.26L15.05 12.14L17.18 18.38L12 14.52L6.82 18.38L8.95 12.14L3.82 8.26L9.91 8.26L12 2Z"
            fill="#b22335"
          />
        </svg>
      );
    }
    return (
      <i
        className={`bi ${rev.icon}`}
        style={{ fontSize: "30px", color: "#b22335" }}
      ></i>
    );
  };

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <section className="cs-section rev-section">
        <div className="container">
          <div className="rev-header">
            <h2 className="cs-title">See Our Online Reviews For Our Client Testimony!</h2>
            <p className="cs-desc text-center">
              We are reviewed by our global client base on sites like Facebook,
              Google, Trustpilot and Yelp. Read our 5-star average reviews below
              to find more about our impact on businesses just like yours!
            </p>
          </div>

          <div className="rev-wrapper cs-content">
            {reviewData.map((rev, index) => (
              <a
                key={index}
                href={rev.link}
                target="_blank"
                rel="noopener noreferrer"
                className="rev-card"
              >
                <div className="rev-icon-box">{renderIcon(rev)}</div>
                <div className="rev-content">
                  <h4>{rev.platform}</h4>
                  <p>Based on {rev.count}</p>
                  <div className="rev-stars">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="bi bi-star-fill"></i>
                    ))}
                  </div>
                </div>
                <i
                  className="bi bi-box-arrow-up-right ms-auto"
                  style={{ color: "#b22335", fontSize: "14px" }}
                ></i>
              </a>
            ))}
          </div>
           <CompanyStats />
        </div>
       
      </section>
    </div>
  );
}